import { ModalProps as AntdModalProps, Modal as ModalAntd } from 'antd'
import { observer } from 'mobx-react-lite'
import * as React from 'react'

import { UIManager } from '@/Core/Managers/UI/UIManager'
import { useProfiler } from '../../Utils/profilerHelpers'

export interface ModalProps extends Omit<AntdModalProps, 'children'> {
    children?: React.ReactNode
}

export const Modal: React.FC<ModalProps> = ({ ...props }) => {
    // Интеграция с профайлером в dev режиме
    const { addEvent, setStatus } = useProfiler('Modal', 'component', '/Core/UI/Modal/Modal.tsx', [props])

    React.useEffect(() => {
        setStatus('active')
        addEvent('initialized', { open: props.open, title: props.title })
    }, [])

    React.useEffect(() => {
        addEvent('state_change', { open: props.open })
        setStatus(props.open ? 'active' : 'inactive')
    }, [props.open])

    const uiManager = new UIManager({
        template: ModalAntd,
        ...props,
    })

    const ObserverComponent = observer(() => {
        addEvent('render', { timestamp: Date.now(), open: props.open })
        return uiManager.render()
    })

    return <ObserverComponent />
}

export default Modal
